<template>
  <div v-if="hasDealer && authLevel.toLowerCase() !== 'interested'">
    <v-navigation-drawer
      :mini-variant.sync="miniVariant"
      ipped="clipped"
      :value="drawer && hideDrawer"
      :disable-resize-watcher="false"
      fixed
      app
    >
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <v-title>Vonex Admin</v-title>
          </v-list-tile-content>
        </v-list-tile>
         <component
          is="AdminMenu"
          :authGroup="authGroup"
          :menuItems=" menuItems
            .filter(x => !allFlags.SOG3648 ? x.title != 'Scheduled Reports' : true)
            .filter(x => !allFlags.SOG3737 ? x.title != 'Employees' : true)
            .filter(x => !allFlags.SOG4174 ? x.title != 'Manage Commissions Targets' : true)"
          :menuTitles="menuTitles"
        />
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex';
const { mapGetters: mapAuthGetters } = createNamespacedHelpers(`orders/auth`);
const { mapActions: mapMenuActions } = createNamespacedHelpers(`orders/menu`);
const { mapState: mapOrderState, mapGetters: mapOrderGetters } =
  createNamespacedHelpers(`orders`);
import { mapMenuMultiRowFields } from '@/store/modules/orders';
import { UserPermission } from '@/models/UserPermission';
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

import AdminMenu from './admin/list-group-admin';
import items from './menuItems';
import menuItems from './menuItems';

export default {
  components: { AdminMenu },
  name: 'sidebar',
  props: ['drawer'],
  data() {
    return {
      menuItems: [],
      menuTitles: [],
      clipped: true,
      fixed: false,
      right: true,
      rightDrawer: false,
      title: 'Vonex',
      enabledClass: 'enabled',
      disabledClass: 'disabled',
      items: items.items,
      miniVariant: false,
    };
  },

  computed: {
    ...mapFeatureFlagGetters(['allFlags']),
    ...mapOrderState([
      'auth',
      'message',
      'rows',
      'address',
      'company',
      'customer',
      'dealer',
      'landline',
      'newChurn',
    ]),
    ...mapOrderGetters([
      'hasDealer',
      'hasOrder',
      'isSigned',
      'hasAddress',
      'isAdmin',
      'isChangeOfAddress',
      'isChangeOfLessee',
      'authGroup',
      'authLevel',
      'isQantas',
      'isResidential',
      'isGrenke',
    ]),
    ...mapMenuMultiRowFields({ savedData: 'rows' }),
    isLoggedIn() {
      return this.$auth.isAuthenticated;
    },
    hideDrawer: function () {
      return this.$route.name == 'OrderApprove'
        ? false
        : this.isLoggedIn == null
        ? false
        : this.isLoggedIn;
    },
    hasStartedOrder: function () {
      return this.$route.name !== 'home';
    },
  },
  watch: {
    $route(to, from) {
      let vm = this;
      vm.getStatus();
    },
  },
  mounted() {
    let vm = this;
    setTimeout(() => {
      vm.getMenuItems();
    }, 500);
  },
  methods: {
    ...mapMenuActions(['getStatus']),
    ...mapActions('userPermissions', [
      'getUserPermissions',
      'getUserPermissionByEmail',
    ]),
    getMenuItems() {
      let vm = this;
      vm.menuItems = vm.$store.getters['menuPermissions/rows'];

      let a = vm.menuItems.map((x) => x.menuItem);
      vm.menuTitles = a.filter((item, i, ar) => ar.indexOf(item) === i);
    },
    hasData: function (el) {
      return this.savedData.map((x) => x.description).includes(el.route);
    },
    navigate: function (route) {
      if (route === 'attachments') {
        this.$router.push({
          path: `/${route}/general`,
        });
      } else if (route === '/') this.$router.push(`${route}`);
      else this.$router.push(`/${route}`);
    },
    status: function (el) {
      //if (this.isAdmin) return true;
      var result = true;
      switch (el) {
        case 'Residential':
          result =
            this.isResidential && (this.isLoggedIn || false) && this.hasDealer;
          break;
        case 'Business':
          result =
            !this.isResidential && (this.isLoggedIn || false) && this.hasDealer;
          break;
        case 'Auth Rep':
          result =
            !this.isResidential && (this.isLoggedIn || false) && this.hasDealer;
          break;
        case 'Guarantor':
          result =
            !this.isResidential &&
            (this.isLoggedIn || false) &&
            this.hasDealer &&
            this.rows[0].customerDetails &&
            this.rows[0].customerDetails.isGuarantor == false;
          break;
        case 'Manage Qantas Admin':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Maintain Rate Plans':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Maintain Handsets':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Dealer Logins':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'View In-progress Orders':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Edit Auth':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Manage Admin Accounts':
          result = this.isLoggedIn && this.isAdmin;
          break;
        case 'Change Address':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            this.isChangeOfAddress;
          break;
        case 'Change Lessee':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            this.isChangeOfLessee;
          break;
        case 'IP Voice':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee) &&
            !this.isResidential;
          break;
        case 'Fixed Line':
        case 'Hardware':
        case 'Internet':
        case 'IP Porting':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee);
          break;
        case 'Attachments':
          result =
            (this.isLoggedIn || false) && this.hasOrder && this.hasAddress;
          break;
        case 'SIP':
        case 'Finance Application':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee);
          break;
        case 'Direct Debit':
        case 'Mobile':
        case 'Inbound':
        case 'Fax':
        //case "Change Lessee":
        case 'Call Management Console':
          result =
            (this.isLoggedIn || false) &&
            this.hasOrder &&
            this.hasAddress &&
            !(this.isChangeOfAddress || this.isChangeOfLessee);
          break;
        case 'Sign and Send':
          if (this.isSigned) return true;
          break;
        default:
          result = true;
          break;
      }

      return result && (this.isAdmin ? true : !this.isSigned);
    },
    collapseService: function () {
      this.IsService = !this.IsService;
    },
    collapseExisting: function () {
      this.IsExisting = !this.IsExisting;
    },
    hasDirectDebit() {
      if (this.rows[0].customerDetails) {
        if (!this.isGrenke) {
          if (this.rows[0].customerDetails.directDebit == 'Yes')
            return this.menuItems.filter((x) => x.title != 'Direct Debit');
          else {
            return this.menuItems;
          }
        }
      } else {
        return this.menuItems;
      }
      return this.menuItems;
    },
  },
};
</script>
<style scoped>
.expand {
  height: auto !important;
  display: block !important;
}

.new-collapse {
  display: none !important;
}
</style>
